import * as RA from 'ramda-adjunct'

// I couldn't find a place where TS exported this, but they might.
// export type TTypeOf = 'string' | 'number' | 'bigint' | 'boolean' | 'symbol' | 'undefined' | 'object' | 'function'
const typeofFunc = (typeofVar: any) => {
  return typeof typeofVar
}
type TTypeOf = ReturnType<typeof typeofFunc>

type TTypeOfOrNull = TTypeOf | 'null'

/** An object that describes the expected shape of a POJO using primitive labels returned by the `typeof` operator.
 * For example:
 *
 * {
 *   foo: 'string',
 *   bar: 'number',
 *   baz: {
 *     buzz: 'boolean',
 *   },
 *   biz: 'function',
 *   burp: ['string', 'undefined'],
 * }
 */
export type TExpectationDescriptor<T> = {
  [k in keyof T]:
    | TTypeOfOrNull
    | TExpectationDescriptor<any>
    | (TExpectationDescriptor<any> | TTypeOfOrNull)[]
}

/**
 * Does some simple `typeof` checks at runtime to verify the given `unknown` object at least has the
 * desired shape at each key of the expectation descriptor `expectations`. Supports multi-level objects
 * and unions of primitive types.
 *
 * Useful for reading third-party inputs into more sane types with some guarantees. See the tests for examples.
 */
export const runtimeTypeValidation = <T>(
  expectations: TExpectationDescriptor<T>,
  validate: unknown // hoping this is a Record<keyof T, any>
): validate is T => {
  if (typeof validate !== 'object' || validate === null) {
    return false
  }

  for (const k of Object.keys(expectations)) {
    // @ts-ignore
    const expectedType: any = expectations[k]
    // @ts-ignore
    const actualValue: any = validate[k]

    if (typeof actualValue === expectedType) {
      continue
    }

    // debugger

    const expectationArray = RA.ensureArray(expectedType)
    // find at least one met expectation
    if (
      expectationArray.find(exp => {
        if (exp === typeof actualValue) {
          return true
        }
        if (exp === 'null' && actualValue === null) {
          // since typeof null === 'object' -_-
          return true
        }
        if (typeof exp === 'object') {
          // recurse
          return runtimeTypeValidation(
            exp as Record<any, TTypeOf | Record<any, TTypeOf>>,
            actualValue
          )
        }
        return false
      })
    ) {
      continue
    }

    return false
  }
  return true
}
